/** @jsx jsx */

import React from 'react';
import { css, jsx } from '@emotion/core';
import renderBlock from 'services/apiHelpers/renderBlock';
import EditableBtn from 'components/lib/EditableBtn';
import getBlockById from 'services/apiHelpers/getBlockById';
import EditableText from 'components/lib/EditableText';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import getMediaParent from 'services/apiHelpers/getMediaParent';

const reRenderedFeedback = feedback =>
  feedback
    ? renderBlock(getBlockById(feedback.props.id), {
        EditableButton: EditableBtn,
        Feedback: ({ children, ...props }) => children,
        Correct: ({ children, ...props }) => children,
        Incorrect: ({ children, ...props }) => children,
        Text: EditableText,
        Image: ({ children, ...props }) => {
          const mediaParent = getMediaParent(props.id);

          return mediaParent ? (
            <Image {...{ ...props, editWrapperType: 1 }} />
          ) : (
            <Image
              {...{ ...props, usePlaceholderValue: true, maxHeight: 30 }}
            />
          );
        },
        Video,
        Transcript: () => null,
        SVG,
        Embed: () => null,
        Media,
      })
    : null;

export default reRenderedFeedback;
